import { render, staticRenderFns } from "./TemplateCertificateCetak.vue?vue&type=template&id=3ffb0640"
import script from "./TemplateCertificateCetak.vue?vue&type=script&lang=js"
export * from "./TemplateCertificateCetak.vue?vue&type=script&lang=js"
import style0 from "./TemplateCertificateCetak.vue?vue&type=style&index=0&id=3ffb0640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports